import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const stimulateFetchVendorList = createAsyncThunk(
    'vendors/stimulateFetchList',
    async ({onResolve}) => {
        return await new Promise(resolve => {
            const vendors = [
                {id: 'asef9483njw9', name: 'Random guy', offerCost: 200, moneyCurrency: '$'},
                {id: 'adas09j094j4', name: 'Random guy bis', offerCost: 400, moneyCurrency: '$'},
            ];

            setTimeout(() => {
                onResolve && onResolve();
                resolve(vendors)
            }, 5000)
        })
    }
)
export const stimulateSearchVendor = createAsyncThunk(
    'vendors/stimulateFetchList',
    async ({keyword, onResolve}) => {
        return await new Promise(resolve => {

            let list = [];

            for (let i = 0; i < 10; i++) {
                list.push({
                    id: `${i}_${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)}`,
                    name: `Random guy ${i}`,
                    offerCost: 100 * i,
                    moneyCurrency: '$'
                })
            }

            list = list.filter(vendor => {
                if (!keyword || keyword.trim() === '')
                    return true;
                else {
                    return vendor.name.toLowerCase().includes(keyword.toLowerCase())
                }

            })

            setTimeout(() => {
                onResolve && onResolve();
                resolve(list)
            }, 5000)
        })
    }
)


const vendorsSlice = createSlice({
    name: 'vendors',
    initialState: {
        list: null,
    },
    reducers: {
        searchVendor: (state, action) => {

        },
        fetchVendorList: state => {

        },

    },
    extraReducers: builder => {
        builder.addCase(stimulateFetchVendorList.fulfilled, (state, action) => {
            state.list = action.payload;
        })

        // builder.addCase(stimulateSearchVendor.fulfilled, (state, action) => {
        //     state.list = action.payload;
        // })
    }
})

export const selectVendors = state => state.vendors;

// export const {searchVendor, fetchVendorList} = vendorsSlice.actions;

export default vendorsSlice.reducer;